import { render, staticRenderFns } from "./Qa.vue?vue&type=template&id=f0192cd0&scoped=true"
import script from "./Qa.vue?vue&type=script&lang=js"
export * from "./Qa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0192cd0",
  null
  
)

export default component.exports